import React, { useState, useId } from "react";
import cls from "./styles.module.scss";

interface InputProps {
  id?: string;
  label?: string;
  type?: "text" | "password" | "email" | "number";
  placeholder?: string;
  value: string;
  hint?: string;
  error?: string;
  disabled?: boolean;
  required?: boolean;
  onChange: (value: string) => void;
}

const Input: React.FC<InputProps> = ({
  id,
  label,
  type = "text",
  placeholder,
  value,
  hint,
  error,
  disabled = false,
  required,
  onChange,
}) => {
  const generatedId = useId();
  const inputId = id || generatedId;
  const [showPassword, setShowPassword] = useState(false);
  const passwordType = showPassword ? "text" : "password";
  const inputType = type === "password" ? passwordType : type;

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div className={cls.inputContainer}>
      {label && (
        <label className={cls.label} htmlFor={inputId}>
          {required && <span>* </span>}
          {label}
        </label>
      )}
      <div className={cls.inputWrapper}>
        <input
          id={inputId}
          type={inputType}
          placeholder={placeholder}
          value={value}
          disabled={disabled}
          className={`${cls.input} ${error ? cls.errorInput : ""} ${
            disabled ? cls.disabledInput : ""
          }`}
          onChange={(e) => onChange(e.target.value)}
        />
        {type === "password" && (
          <button
            type="button"
            className={cls.toggleButton}
            onClick={togglePasswordVisibility}
            disabled={disabled}
          >
            {showPassword ? "Hide" : "Show"}
          </button>
        )}
      </div>
      {error && <div className={cls.errorText}>{error}</div>}
      {hint && <div className={cls.hintText}>{hint}</div>}
    </div>
  );
};

export default Input;
